<!-- this can also be implemented using list tile -->
<template>
	<BasicTile @click="tileClicked()" class="w-100 elevation-0" style="border: none !important;">
		<div class="notification" :class="{ 'notification--unread': !isNotificationRead }">


			<div v-if="!isNotificationRead" class="notification__status">
				<span class="notification__status-indicator"></span>
			</div>


			<div class="notification__icon">
				<slot name="icon"></slot>
			</div>


			<div class="notification__content">
				<div class="notification__content--title">
					<slot name="title"></slot>
				</div>
				<div class="notification__content--description">
					<slot name="description"></slot>
				</div>
			</div>


			<div class="notification__reward">
				<coin-chip>
					<template v-slot:icon>
						<slot name="chip-icon"></slot>
					</template>
					<template v-slot:amount>
						<span class="notification__reward-text text-body-2 font-weight-bold ml-1">
							+<slot name="coins"></slot>
						</span>
					</template>
				</coin-chip>
			</div>


		</div>
	</BasicTile>
</template>



<script setup>

import CoinChip from '@/components/Common/CoinChip.vue';
import BasicTile from '@/components/Tiles/Basic-Tile.vue';


const props = defineProps({
	isNotificationRead: {
		type: Boolean,
		default: false,
		required: true
	}
});


const emit = defineEmits(['click']);

const tileClicked = () => {
	emit('click');
}

</script>